import { Flex, Icon } from '@chakra-ui/react';
import { Expand04 } from '@kula-ai/icons/outline/Expand04';
import { Minimize01 } from '@kula-ai/icons/outline/Minimize01';
import { Move } from '@kula-ai/icons/outline/Move';
import { DrilldownBreadcrumb } from './DrilldownBreadCrumb';

export const DrilldownHeader = ({
  drilldownContext,
  modalSize,
  setModalSize,
}) => {
  const handleMouseDown = (e) => {
    e.preventDefault();

    const modal = e.currentTarget.closest('.chakra-modal__content');
    if (!modal) return;

    const startX = e.clientX;
    const startY = e.clientY;
    const { left, top } = modal.getBoundingClientRect();

    modal.style.cursor = 'grabbing';

    const onMouseMove = (moveEvent) => {
      const dx = moveEvent.clientX - startX;
      const dy = moveEvent.clientY - startY;

      let newLeft = left + dx;
      let newTop = top + dy;

      const modalWidth = modal.offsetWidth;
      const modalHeight = modal.offsetHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // Prevent dragging out of bounds
      newLeft = Math.max(0, Math.min(newLeft, windowWidth - modalWidth));
      newTop = Math.max(0, Math.min(newTop, windowHeight - modalHeight));

      modal.style.position = 'fixed';
      modal.style.left = `${newLeft}px`;
      modal.style.top = `${newTop}px`;
      modal.style.margin = '0';
      modal.style.transform = 'none';
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      modal.style.cursor = 'default';
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const toggleModalSize = () => {
    const modal = document.querySelector(
      '.chakra-modal__content'
    ) as HTMLElement;

    const isGoingFull = modalSize !== 'full';
    setModalSize(isGoingFull ? 'full' : '5xl');

    if (isGoingFull && modal) {
      modal.style.position = 'fixed';
      modal.style.left = '';
      modal.style.top = '';
      modal.style.margin = '';
      modal.style.transform = '';
    }
  };

  return (
    <Flex
      mt="3px"
      mr="30px"
      gap="20px"
      alignItems="center"
      justifyContent="space-between"
    >
      <DrilldownBreadcrumb context={drilldownContext} />
      <Flex gap="8px">
        {modalSize !== 'full' && (
          <Icon
            as={Move}
            cursor="grab"
            w="14px"
            h="14px"
            onMouseDown={handleMouseDown}
          />
        )}

        <Icon
          as={modalSize === 'full' ? Minimize01 : Expand04}
          cursor="pointer"
          w="14px"
          h="14px"
          onClick={toggleModalSize}
        />
      </Flex>
    </Flex>
  );
};
